import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import _ from 'lodash';
import 'antd/dist/antd.css';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';

export class DevicePermissionStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      devices: [],
      defaultDevices: [],
      offset: 0,
      limit: 100,
      search: null,
      filterOutStatus: [],
      filterCategory: [],
      tenantIds: [],
    });
  }

  async setData(task, data, getDevices = true) {
    this[task] = data;
    if (getDevices) {
      await this.getDevicesForPermission(
        this.filterOutStatus,
        this.offset,
        this.limit,
        this.search,
        this.sort,
        this.order,
      );
    }
  }

  async getDevicesForPermission(filterOutStatus = [], offset = 0, limit = 15, search = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.filterOutStatus = filterOutStatus;
    queryOption.offset = offset;
    queryOption.limit = limit;
    queryOption.tenantIds = JSON.stringify(this.tenantIds);
    queryOption.filterCategory = JSON.stringify(this.filterCategory);
    if (search) {
      queryOption.search = search;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/device/permission/list`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const devices = res.body || {};
        let list = (devices.data || []).map((val) => {
          return {
            id: val.id,
            label: val.name && val.name.length > 0 ? `${val.name} (${val.serial})` : val.serial,
            type: val.deviceVersion ? val.deviceVersion.name : null,
            category: val.deviceVersion ? val.deviceVersion.category : '',
          };
        });
        devices.data = list;
        this.defaultDevices = devices;
        return (this.devices = devices);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  filterDeviceCategory(categories) {
    let tmpDevices = _.cloneDeep(this.defaultDevices);
    if (categories.length > 0) {
      const results = tmpDevices.data.filter((device) => categories.includes(device.category));
      tmpDevices.data = results;
    }
    this.devices = tmpDevices;
  }
}

export default new DevicePermissionStore();
